import { render, staticRenderFns } from "./FormWordings.vue?vue&type=template&id=e28fec82&"
import script from "./FormWordings.vue?vue&type=script&lang=js&"
export * from "./FormWordings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports